import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFlowChart = () => {
  return (
    <g>
      <path d="m10.5547 4.5806v-3.0684h.73a.7.7 0 1 0 0-1.4h-6.57a.7.7 0 1 0 0 1.4h.73v3.0684a5.95 5.95 0 1 0 5.1094 0zm-2.5547 9.9072a4.5327 4.5327 0 0 1 -3.6412-1.85h1.7867a.7.7 0 1 0 0-1.4h-2.4833a4.47 4.47 0 0 1 -.1412-.6h2.6245a.7.7 0 1 0 0-1.4h-2.642a4.5027 4.5027 0 0 1 .1392-.6h2.5028a.7.7 0 0 0 0-1.4h-1.7955a4.561 4.561 0 0 1 2.0436-1.5415.699.699 0 0 0 .4521-.6543v-3.53h2.3086v3.53a.699.699 0 0 0 .4522.6543 4.5409 4.5409 0 0 1 -1.6065 8.7915z" />
    </g>
  );
};

export default withIcon(IconFlowChart);
